
import { ElMessageBox, ElMessage } from 'element-plus';

const tm_message_box = {
  alert: function (title, message, config = { type: 'info' }) {
    const defaultConfig = Object.assign(
      {
        showCancelButton: false,
        showConfirmButton: false,
        duration: 2000,
      },
      config
    );
    if (config.type == 'error') {
      delete defaultConfig.duration;
      defaultConfig.showConfirmButton = true;
    }
    return generateBox({ title, message, config: defaultConfig });
  },
  confirm: function (title, message, config) {
    return generateBox({ title, message, config });
  },
  toast: function (message, config = { type: 'info' }) {
    ElMessage({
      message,
      ...config,
      customClass: 'tm-el-message',
    });
  },
  errorBox: function (response, config = {}) {
    // 提示特殊化
    let message = '',
      arr = response.data.errorReason || [],
      count = 0;

    arr.map((n) => {
      count++;
      message += '<i class ="iconfont tm-icon-i1"></i>' + count + '.' + n + '</br>';
    });

    const title =
      response.data.successReason.length > 0 && response.data.errorReason.length
        ? (config.tip || '除以下失败外，其余操作成功')
        : '';
    const defaultConfig = {
      type: 'warning',
      dangerouslyUseHTMLString: true,
      showConfirmButton: true,
      showCancelButton: false,
      ...config,
    };
    message = `<div class="toast-error-list">${message}</div>`;
    return generateBox({ title, message, config: defaultConfig });
  },
};
const generateBox = function ({ title = '', message, config = {} }) {
  config.alignCenter = config.alignCenter || true;
  let options = {
    ...config,
    showClose: config.showClose || false,
    type: config.type || 'info', //success / info / warning / error
    confirmButtonText: config.confirmButtonText || '确认',
    cancelButtonText: config.cancelButtonText || '取消',
    distinguishCancelAndClose: config.distinguishCancelAndClose || false,
    dangerouslyUseHTMLString: config.dangerouslyUseHTMLString || false,
    showCancelButton: typeof config.showCancelButton === 'boolean' ? config.showCancelButton : true,
    showConfirmButton:
      typeof config.showConfirmButton === 'boolean' ? config.showConfirmButton : true,
    closeOnClickModal: false,
    buttonsize: 'large',
    center: true,
  };

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      ElMessageBox.confirm(message, title, {
        customClass: `tm-message-box ${config.alignCenter && 'content-center'}`,
        ...options,
      })
        .then(() => {
          resolve();
        })
        .catch((res) => {
          reject(res);
        });
    }, 0);

    //alert 无按钮时 自动关闭
    if (
      config.duration &&
      config.showConfirmButton === false &&
      config.showCancelButton === false
    ) {
      setTimeout(() => {
        resolve();
        ElMessageBox.close();
      }, config.duration);
    }
  });
};
export default tm_message_box;
